module.exports ={
    template: {
        demo:'テンプレート',
        toolsTip: [
            {
                label:'選択',
                iconUrl:'/static/images/tool-select.png',
                type:'select'
            },{
                label:'テキスト',
                iconUrl:'/static/images/tool-text.png',
                type: 'text'
            },{
                label:'長方形',
                iconUrl:'/static/images/tool-rect.png',
                type: 'rect'
            },{
                label:'スクエア',
                iconUrl:'/static/images/tool-square.png',
                type: 'square'
            },{
                label:'楕円',
                iconUrl:'/static/images/tool-ellipse.png',
                type: 'ellipse'
            },{
                label:'円形',
                iconUrl:'/static/images/tool-circle.png',
                type: 'circle'
            },{
                label:'直線',
                iconUrl:'/static/images/tool-line.png',
                type: 'line'
            },{
                label:'アイコン',
                iconUrl:'/static/images/tool-icon.png',
                type: 'icon'
            },{
                label:'画像',
                iconUrl:'/static/images/tool-img.png',
                type: 'img'
            },{
                label:'バーコード',
                iconUrl:'/static/images/tool-barcode.png',
                type:'barcode'
            },{
                label:'QRコード',
                iconUrl:'/static/images/tool-qrcode.png',
                type:'qrcode'
            },{
                label:'削除する',
                iconUrl:'/static/images/tool-del.png',
                type: 'del'
            }
        ],
        icons:[
            {label:"携帯電話", prop:"icofont-iphone"},
            {label:"銀行カード", prop:"icofont-credit-card"},
            {label:"場所", prop:"icofont-location-pin"},
            {label:"WeChat", prop:"icofont-wechat"},
            {label:"Alipay", prop:"icofont-brand-alipay"},
            {label:"ユーロ", prop:"icofont-euro"},
            {label:"米ドル", prop:"icofont-dollar"},
            {label:"中国人民元", prop:"icofont-yen"},
            {label:"英ポンド", prop:"icofont-pound"},
            {label:"飛行機", prop:"icofont-airplane-alt"},
            {label:"チェックマーク1", prop:"icofont-check-circled"},
            {label:"チェックマーク2", prop:"icofont-check"},
            {label:"リサイクル可能", prop:"icofont-recycle"},
            {label:"チェックボックス", prop:"icofont-tick-boxed"},
            {label:"警告する1", prop:"icofont-warning-alt"},
            {label:"警告する2", prop:"icofont-warning"},
            {label:"WIFI1", prop:"icofont-wifi"},
            {label:"WIFI2", prop:"icofont-wifi-alt"},
            {label:"Bluetooth", prop:"icofont-bluetooth"},
            {label:"禁じる", prop:"icofont-not-allowed"},
            {label:"禁煙", prop:"icofont-no-smoking"},
            {label:"固定電話", prop:"icofont-ui-dial-phone"},
            {label:"トラック", prop:"icofont-truck-alt"},
            {label:"リボン", prop:"icofont-bow"},
            {label:"応援", prop:"icofont-support"},
            {label:"笑う", prop:"icofont-laughing"},
            {label:"スマイル", prop:"icofont-simple-smile"}                        
        ],
        panelMsg:{
            screenSize: '画面：',
            screenColor: {
                red: '黒と白赤',
                yellow: '黒と白の黄色',
                black: '黒白'
            },
            screenOrientation: '画面の向き：',
            screenOrientationOpt: ['横型', '直立'],
            screenWidth: '画面幅:',
            screenHeight: '画面の高さ:',
            dpi: '決議：',
            x: 'x',
            y: 'y',
            w: 'w',
            h: 'h',
            cx: 'cx',
            cy: 'cy',
            r: 'r',
            rx: 'rx',
            ry: 'ry',
            x1: 'x1',
            y1: 'y1',
            x2: 'x2',
            y2: 'y2',
            text: 'テキスト',
            // barWOpt:[95,190],
            barWOpt:[1, 2, 3, 4],
            fontFamily: '書体',
            fontSize: 'フォントサイズ',
            align: '整列',
            anchor: [
                {
                    label: '左揃え',
                    iconUrl: '/static/images/panel-left.png',
                    prop:'start'
                },{
                    label: '中央揃え',
                    iconUrl: '/static/images/panel-middle.png',
                    prop:'middle'
                },{
                    label: '右揃え',
                    iconUrl: '/static/images/panel-right.png',
                    prop:'end'
                }
            ],
            mutiAnchor: [
                {
                    label: '垂直の等間隔',
                    iconUrl: '/static/images/vE.png',
                    disIconUrl: '/static/images/vE-disable.png',
                    prop:'vE',
                    eMethod: 'vEChange'
                },{
                    label: '水平の等間隔',
                    iconUrl: '/static/images/hE.png',
                    disIconUrl: '/static/images/hE-disable.png',
                    prop:'hE',
                    eMethod: 'hEChange'
                },{
                    label: '左揃え',
                    iconUrl: '/static/images/hAlignL.png',
                    disIconUrl: '/static/images/hAlignL-disable.png',
                    prop:'hAlignL',
                    eMethod: 'hAlignLChange'
                },{
                    label: '中央揃え',
                    iconUrl: '/static/images/hAlignM.png',
                    disIconUrl: '/static/images/hAlignM-disable.png',
                    prop:'hAlignM',
                    eMethod: 'hAlignMChange'
                },{
                    label: '右揃え',
                    iconUrl: '/static/images/hAlignR.png',
                    disIconUrl: '/static/images/hAlignR-disable.png',
                    prop:'hAlignR',
                    eMethod: 'hAlignRChange'
                },{
                    label: '下揃え',
                    iconUrl: '/static/images/vAlignB.png',
                    disIconUrl: '/static/images/vAlignB-disable.png',
                    prop:'vAlignB',
                    eMethod: 'vAlignBChange'
                },{
                    label: '上から下に揃える',
                    iconUrl: '/static/images/vAlignM.png',
                    disIconUrl: '/static/images/vAlignM-disable.png',
                    prop:'vAlignM',
                    eMethod: 'vAlignMChange'
                },{
                    label: '上揃え',
                    iconUrl: '/static/images/vAlignT.png',
                    disIconUrl: '/static/images/vAlignT-disable.png',
                    prop:'vAlignT',
                    eMethod: 'vAlignTChange'
                }
            ],
            fontWeight: '太字',
            fontWeightOpt: [
                {
                    label: '普通',
                    prop: 'normal'
                },{
                    label: '太字',
                    prop: 'bold'
                }
            ],
            fontFamilyOpt: [
                {
                    label: 'WqyBitmapSong',
                    prop: 'WqyBitmapSong'
                },{
                    label: 'AlibabaPuhui',
                    prop: 'AlibabaPuhui'
                }, {
                    label: 'SourceHanSansJP',
                    prop: 'SourceHanSansJP'
                }
            ],
            textStyle: 'テキスト効果',
            needPre:'プレフィックスを表示',
            color: '埋める',
            // optionalColors: [
            //     {
            //         label: '红',
            //         value: '#9a2835'
            //     },{
            //         label: '黄',
            //         value: '#f1b804'
            //     },{
            //         label: '黑',
            //         value: '#000000'
            //     }
            // ],
            // optionalColors: {
            //     red: [{
            //         label: '红',
            //         value: '#9a2835'
            //     },{
            //         label: '黑',
            //         value: '#000000'
            //     }],
            //     yellow: [{
            //         label: '黄',
            //         value: '#f1b804'
            //     },{
            //         label: '黑',
            //         value: '#000000'
            //     }],
            //     black: [{
            //         label: '黑',
            //         value: '#000000'
            //     }]
            // },
            optionalColors: {
                red: {
                    hexVal: '#9a2835',
                    label: '赤',
                    // colors: ['red', 'black']
                    colors: ['red', 'black', 'white']
                },
                yellow: {
                    hexVal: '#f1b804',
                    label: '黄',
                    // colors: ['yellow', 'black']
                    colors: ['yellow', 'black', 'white']
                },
                black: {
                    hexVal: '#000000',
                    label: '黒',
                    // colors: ['black']
                    colors: ['black', 'white']
                },
                white: {
                    hexVal: '#ffffff',
                    label: '白',
                    colors: []
                }
            },
            brType: 'バーコードタイプ',
            brTypeOpts: [
                {
                    label: 'ean13',
                    prop: 'ean13'
                },{
                    label: 'code128',
                    prop: 'code128'
                }
            ],
            bindData: 'データの連携',
            unBind: '連携を解除',
            bdPlaceholder: '選択してください',
            bindDataOpt:[
                {
                    label: '商品番号',
                    // sample: '编号:1101',
                    type:'text',
                    prop: 'proNo'
                },{
                    label: '商品名',
                    // sample: '云里物里电子标签',
                    type:'text',
                    prop: 'name'
                },{
                    label: '商品の略称',
                    // sample: '电子标签',
                    type:'text',
                    prop: 'proAbbr'
                },{
                    label: 'ブランド',
                    // sample: '云里物里',
                    type:'text',
                    prop: 'brand'
                },{
                    label: '価格',
                    // sample: '￥68.00',
                    type:'text',
                    prop: 'price'
                },{
                    label: '産地',
                    // sample: '原产地:中国深圳',
                    type:'text',
                    prop: 'origin'
                },{
                    label: 'ランク',
                    // sample: '等级:A',
                    type:'text',
                    prop: 'rating'
                },{
                    label: '単位',
                    // sample: '单位:个',
                    type:'text',
                    prop: 'piece'
                },{
                    label: '規格',
                    // sample: '规格:2901',
                    type:'text',
                    prop: 'specification'
                },{
                    label: 'ベンダー',
                    // sample: '供货商:云里物里',
                    type:'text',
                    prop: 'supplierName'
                },{
                    label: 'バーコードテキスト',
                    sample: '6666666666666',
                    type:'text',
                    prop: 'barcodeText'
                },{
                    label: 'QRコードテキスト',
                    sample: 'http://minewtech.com',
                    type:'text',
                    prop: 'qrcodeText'
                },{
                    label: 'バーコード',
                    type:'barcode',
                    prop: 'barcode'
                },{
                    label: 'QRコード',
                    type:'qrcode',
                    prop: 'qrcode'
                }
            ],
            sampleContent:{
                "proNo":'1101',
                "name":'Minew電子棚札',
                "proAbbr": '電子棚札',
                "brand": 'Minew',
                "price":'￥68.00',
                "origin":'深セン、中国',
                "rating":'A',
                "piece":'个',
                "specification":'2901',
                "supplierName":'Minew',
                "barcode":'6666666666666',
                "barcodeText":'6666666666666',
                "qrcode": 'http://minewtech.com',
                "qrcodeText": 'http://minewtech.com',
                "unBind": 'テキストコンテンツ',
                "imgUrl": '/static/images/logo.jpg',
                "text": 'テキスト'
            },
            samplePrefix:{
                "proNo":'番号：',
                "name":'品名：',
                "proAbbr": '略称：',
                "brand": 'ブランド：',
                "price":'',
                "origin":'産地：',
                "rating":'ランク：',
                "piece":'単位：',
                "specification":'規格：',
                "supplierName":'ベンダー：',
                "barcodeText":'',
                "qrcodeText": '',
                "unBind": '接頭辞:'
            }
        },
        validMsg: {
            minFs: 'フォントサイズは9以上',
            maxFs: 'フォントサイズは1000以下',
            minW: '幅は30以上',
            maxW: '幅は1000以下',
            minH: '高さは30以上',
            maxH: '高さは1000以下',
            barMinH: '高さは10以上です',
            barMaxH: '高さは1000以下',
            imgMinW: '幅は{w}以上',
            imgMaxW: '幅は{w}以下',
            imgMinH: '高さは{h}以上',
            imgMaxH: '高さは{h}以下',
            num: '整数を入力してください',
            contentFormat: '価格効果を使用する場合は小数を入力する必要があります',
            uploadType: 'アップロードする画像はJPGまたはPNG形式のみで、ファイルサイズは500KB以内にする必要があります。',
            uploadSizeLt: '画像サイズは{size}以内でなければなりません！',
            demoNameMsg: 'テンプレート名を入力してください',
            demoNameFail: '失敗しました。再入力してください',
            exist: 'テンプレート名はすでに存在します',
            zoomMsg: '50％-200％の百分数を入力してください',
            minOne: '0より大きい整数を入力してください',
            minOneW: '幅は0以上',
            minOneH: '高は0以上',
            charAndNum: '文字または番号字を入力してください'
        },
        editTip:{
            success: 'テンプレートを保存しました',
            exist: '保存されたテンプレートが存在しないか、削除されました',
            fail: 'テンプレートの保存に失敗しました',
            permission: 'テンプレートを変更する権限がありません',
            valid: 'テンプレートの保存にエラー発生。データは正しくありません。'
        },
        getTip: {
            exist: '編集したテンプレートが存在しないか、削除されています'
        },
        scaleTip: 'ヒント：ボックス内でマウスホイールを回して、グラフィックをズームします',
        cancel: 'キャンセル',
        sure: '保存',
        drawTip: {
            loadErr: '画像を読み込めませんでした',
            changeColorErr: '塗りつぶしに失敗しました',
            chooseImg: '描く絵を選んでください'       
        },
        submiting: '保存中...',
        editDemo: 'テンプレートを編集'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/template.js